export class Option<T = any> {
  key: number;
  label: string;
  fullObject?: T;

  constructor(key: number, label: string, fullObject?: T) {
    this.key = key;
    this.label = label;
    this.fullObject = fullObject;
  }
}

export class Group<TMain = any, TSub = any> {
  key: number;
  label: string;
  options: Option<TSub>[];
  fullObject?: TMain;

  constructor(
    key: number,
    label: string,
    options: Option<TSub>[],
    fullObject?: TMain
  ) {
    this.key = key;
    this.label = label;
    this.options = options;
    this.fullObject = fullObject;
  }
}

export class OptionResponse<TMain = any, TSub = any> {
  groups: Group<TMain, TSub>[];

  constructor(groups: Group<TMain, TSub>[]) {
    this.groups = groups;
  }
}
